import React, { Component } from 'react';
import { fetchApi } from 'api/fetchApi';
import { handleError } from 'utils/errors';
import { Select } from './select';
import { Attributes, EventTarget } from './types';

interface IProps {
  name: string;
  value: string;
  attributes: Attributes;
  disabled: boolean;
  required: boolean;
  onChange: (e: EventTarget) => void;
  onSetChange: (name: string, value: Array<string> | Record<string, string>) => void;
  getLabel: (attributes: Attributes, key: string) => string;
}

interface IState {
  options: Array<{ key: number; name: string }>;
  disabled: boolean;
}

class DynamicDropdown extends Component<IProps, IState> {
  state: IState = {
    options: [],
    disabled: true,
  };

  componentDidMount() {
    void this.getOptions();
  }

  getOptions = async () => {
    const { attributes, disabled } = this.props;
    const { dynamicDroppdownSetting = {}, disabled: disabledField } = attributes;

    if (!dynamicDroppdownSetting.remoteUrl) {
      return false;
    }

    try {
      const response = await fetchApi.post<Array<{ id: number; name: string }>>(dynamicDroppdownSetting.remoteUrl);

      const options = response.data.map((o) => ({ name: o.name, key: o.id }));

      this.setState({ options, disabled: !!disabled || !!disabledField });
    } catch (error) {
      handleError('Failed to fetch options', error);
    }
  };

  render() {
    const { disabled: disabledForm, required } = this.props;
    const { options, disabled } = this.state;

    return (
      <Select
        {...this.props}
        options={options}
        required={required}
        canBeEmptyValue
        disabled={disabled || disabledForm}
      />
    );
  }
}

export default DynamicDropdown;
